import { render, staticRenderFns } from "./uploadcostedit.vue?vue&type=template&id=bdb373fc&scoped=true&"
import script from "./uploadcostedit.vue?vue&type=script&lang=js&"
export * from "./uploadcostedit.vue?vue&type=script&lang=js&"
import style0 from "./uploadcostedit.vue?vue&type=style&index=0&id=bdb373fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb373fc",
  null
  
)

export default component.exports